<template>
  <button
    v-if="available && compact"
    type="button"
    class="flex-none h-8 px-[10px] rounded-lg border border-solid border-white/25 bg-transparent text-white/90 font-[inherit] text-xs font-medium cursor-pointer whitespace-nowrap hover:bg-white/10"
    :title="enabled ? 'Вернуть старый интерфейс чата' : 'Включить новый интерфейс чата'"
    @click="enabled = !enabled"
  >
    {{ enabled ? 'Старый вид' : 'Новый вид' }}
  </button>

  <div
    v-else-if="available"
    role="radiogroup"
    aria-label="Интерфейс чата"
    class="inline-flex items-center gap-2 text-sm text-chat-soft"
  >
    <span>Интерфейс чата</span>
    <span class="inline-flex gap-1 p-1 bg-chat-tab border border-solid border-chat-line rounded-xl">
      <button
        v-for="option in options"
        :key="String(option.value)"
        type="button"
        role="radio"
        class="h-8 px-3 border-0 rounded-[9px] font-[inherit] text-sm font-medium cursor-pointer text-chat-ink"
        :class="enabled === option.value ? 'bg-white shadow-[0_1px_2px_rgba(33,37,41,0.12)]' : 'bg-transparent'"
        :aria-checked="enabled === option.value"
        @click="enabled = option.value"
      >
        {{ option.label }}
      </button>
    </span>
  </div>
</template>

<script setup lang="ts">
import { useFeatureFlagToggle } from '@/shared/lib/feature-flags';

defineProps<{
  /** Кнопка для тёмной шапки окна чата вместо сегментов */
  compact?: boolean;
}>();

const options = [
  { value: false, label: 'Старый' },
  { value: true, label: 'Новый' }
];

const { available, enabled } = useFeatureFlagToggle('chatNewDesign');
</script>
